import React from "react";
// Common Components
import TableTemplate, {
  ITableUI,
} from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./Additional";
// Requests
import { getFundNoRiskTable } from "src/Requests/fundNoRiskTask";
import {
  IFundNoRiskSearchParam,
  IFundNoRiskTableReport,
} from "src/Interfaces/fundNoRisk";

interface IProps {
  refreshFlag: boolean;
  onFetchComplete: () => void;
  searchParams: IFundNoRiskSearchParam;
  onSelectedRowsChange: (selectedRowsIds: number[]) => void;
}
const FundNoRiskTable: React.FC<IProps> = ({
  refreshFlag,
  onFetchComplete,
  searchParams,
  onSelectedRowsChange,
}) => {
  const TableUI = React.useCallback(
    ({ reports, onAction }: ITableUI<IFundNoRiskTableReport>) => (
      <CommonTableUI
        reports={reports}
        onAction={onAction}
        refreshFlag={refreshFlag}
        AdditionalBody={Additional}
        tableBoxClassName="!max-h-[800px] !overflow-y-auto"
        withSelect
        stickySelectColumn
        onSelectedRowsChange={onSelectedRowsChange}
      />
    ),
    [onSelectedRowsChange, refreshFlag],
  );
  return (
    <TableTemplate
      TableUI={TableUI}
      refreshTableTime={30000}
      pagesize={300}
      getDataTable={getFundNoRiskTable}
      onFetchComplete={onFetchComplete}
      searchParameters={searchParams}
    />
  );
};

export default FundNoRiskTable;
